import {Injectable} from '@angular/core';
import {ofType} from '@ngrx/effects';
import {ActionsSubject, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {AppState} from 'src/app/core/core.module';
import {Dibujo} from 'src/app/chacra-core';
import {
  ChacrasChangePendienteAction,
} from '../../store/entities/shared/chacras/chacras.actions';
import {
  ADJUNTOS_LAYER,
  CHACRAS_LAYER,
  PENDIENTES_LAYER,
  ZONAS_LAYER
} from '../constants';
import * as chacrasActions from '../../store/entities/shared/chacras/chacras.actions';
import * as zonasActions from '../../store/entities/shared/zonas-exclusion/zonas-exclusion.actions';
import {map} from 'rxjs/operators';
import {MapAction} from '../enums';
import {CurrentFeatureItem} from '../models';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResultType} from 'src/app/shared';
import {AdjuntosDeleteRequestAction} from '../../store/entities/shared/adjuntos/adjuntos.actions';
import {ZonasExclusionDeleteRequestAction} from "../../store/entities/shared/zonas-exclusion/zonas-exclusion.actions";

@Injectable({
  providedIn: 'root'
})
export class ControllerMapService {

  DIALOG_WIDTH = '500px';
  DIALOG_MAX_HEIGHT = '500px';

  observers: Observable<any>[] = [];

  constructor(protected store: Store<AppState>, protected actionsSubj: ActionsSubject, protected dialog: MatDialog) {
    this.observers = [

      // Chacra Pendiente Change
      this.actionsSubj.pipe(
        ofType(chacrasActions.ChacrasActionTypes.CHACRAS_CHANGE_PENDIENTE),
        map((action: chacrasActions.ChacrasChangePendienteAction) => action.payload.item),
      ).pipe(map(item => {
        return {
          item,
          action: MapAction.new,
          featureName: PENDIENTES_LAYER.name
        };
      })),

      // Zonas Add
      this.actionsSubj.pipe(
        ofType(zonasActions.ZonasExclusionActionTypes.ADD_SUCCESS),
        map((action: zonasActions.ZonasExclusionAddSuccessAction) => action.payload.item),
      ).pipe(map(item => {
        return {
          item: null,
          action: MapAction.new,
          featureName: CHACRAS_LAYER.name
        };
      })),

      // Zonas Delete
      this.actionsSubj.pipe(
        ofType(zonasActions.ZonasExclusionActionTypes.DELETE_SUCCESS),
        map((action: zonasActions.ZonasExclusionDeleteSuccessAction) => action.payload),
      ).pipe(map(_ => {
        return {
          item: null,
          action: MapAction.new,
          featureName: CHACRAS_LAYER.name
        };
      })),
    ];
  }

  saveItem(dibujo: Dibujo, item: any, featureName: string,
           action: MapAction, extraData?: any) {

    // Pendientes
    if (featureName === PENDIENTES_LAYER.name) {
      item.chacraFactorLSGeometriaAsignado = dibujo.dibujoGeometria;
      this.store.dispatch(new ChacrasChangePendienteAction({item}));
    }
  }

  deleteItem(currentMapItem: CurrentFeatureItem) {
    const item = currentMapItem.item;
    if (currentMapItem.featureName === ADJUNTOS_LAYER.name) {
      this.openConfirmDialog(
        'Eliminar Adjunto',
        `¿Confirma la eliminación del adjunto ${item.adjuntoNombre}?`,
        new AdjuntosDeleteRequestAction({item})
      );
    }
    if (currentMapItem.featureName === ZONAS_LAYER.name) {
      this.openConfirmDialog(
        'Eliminar Parche de Elevación',
        `¿Confirma la eliminación de la parche de elevación ${item.zonaExclusionId}?`,
        new ZonasExclusionDeleteRequestAction({item})
      );
    }
  }

  openConfirmDialog(title: string, question: string, action: any) {
    const inData: ConfirmDialogData = {
      title,
      question,
      result: ConfirmDialogResultType.Cancel
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: this.DIALOG_WIDTH,
      maxHeight: this.DIALOG_MAX_HEIGHT,
      data: inData
    });
    dialogRef.afterClosed().subscribe(outData => {
      if (outData && outData.result === ConfirmDialogResultType.Ok) {
        if (action) {
          this.store.dispatch(action);
        }
      }
    });
  }
}
